export default __webpack_public_path__ + "static/media/time-line-default.9d7240da.svg";